import React, { useContext } from 'react';
import { Modal as AntModal } from 'antd';
import {
  useModalMethods,
  useModalWatch,
} from '../../shared/packages/modalManager';
import { modalNames } from '../../shared/configs/modal';
import { useFormMethods } from '../../../../helpers/formManager';
import { StrategyProvider, useStrategyContexts } from './strategies';
import { normalizeFormValues } from './utils';
import styles from './index.module.scss';

const AttachmentsFormModal = () => {
  return (
    <StrategyProvider>
      <Modal />
    </StrategyProvider>
  );
};

export default AttachmentsFormModal;

const name = modalNames.attachmentsForm;

function Modal() {
  const isOpen = useModalWatch({
    name,
    selector: (state) => state?.isOpen,
    defaultValue: false,
  });

  const { SubmitContext, ModalPropsContext, fields } = useStrategyContexts();

  const { onSubmit, loading } = useContext(SubmitContext);

  const props = useContext(ModalPropsContext);

  const { closeAndKeepProps } = useModalMethods();

  const { handleSubmit } = useFormMethods();

  const handleClose = () => {
    closeAndKeepProps(name);
  };

  const handleOk = handleSubmit(async (values) => {
    const normalizedValues = normalizeFormValues(values);
    await onSubmit(normalizedValues);
  });

  return (
    <AntModal
      visible={isOpen}
      onCancel={handleClose}
      centered
      maskClosable={false}
      width={540}
      onOk={handleOk}
      confirmLoading={loading}
      {...props}
    >
      <form className={styles.form}>{fields}</form>
    </AntModal>
  );
}
